var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{staticClass:"pa-0",attrs:{"disabled":!_vm.sectionItems.length,"loading":_vm.grade.section.fetching,"items":_vm.sectionItems,"outlined":"","dense":"","label":"Select section"},on:{"change":_vm.setSection}})
}
var staticRenderFns = []

export { render, staticRenderFns }